import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {StatisticState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: StatisticState = {
    mailNotifyGroupBy: [
        'hour',
        'day',
        'week',
        'month',
    ],
    mailNotifyGroupByOptionally: [
        'broker_account_login',
        'mn_service_name',
        'mn_tmpl',
        'routes',
        'message_type',
        'template_id',
        'bulk_id',
    ],

    mailNotifyStatisticGroup: null,
    mailNotifyStaticDetail: null,
    mailNotifyStaticDetailFlag: '',
};


export const mailNotifyStatistic: Module<StatisticState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
